import React from 'react';
import { useIntl } from 'react-intl/lib';
import { Alignment, Button, Icon, JustifyContents } from 'tacho-ui';
import { FormStatusComponent } from '../FormStatus/formStatusComponent';

interface TachoConfirmationFooterProps {
    pending?: boolean;
    submitDisabled?: boolean;
    errorToTranslate?: string;
    additionalButton?: () => JSX.Element;
    onSubmit: () => void;
    onToggle: () => void;
    onDismiss?: () => void;
}

export function TachoConfirmationFooter(props: TachoConfirmationFooterProps): JSX.Element {
    const { formatMessage } = useIntl();
    return (
        <>
            <FormStatusComponent formPending={props.pending || false} formErrorMessageToTranslate={props.errorToTranslate} />
            <Button
                justify={JustifyContents.center}
                align={Alignment.center}
                gap={4}
                text={formatMessage({ id: 'confirmationModalCancel' })}
                icon={Icon.Clear}
                className="secondary"
                disabled={props.submitDisabled}
                loading={props.pending}
                onClick={() => {
                    props.onDismiss && props.onDismiss();
                    props.onToggle();
                }}
            />
            <Button
                justify={JustifyContents.center}
                align={Alignment.center}
                gap={4}
                text={formatMessage({ id: 'confirmationModalSubmit' })}
                icon={Icon.Check}
                className="secondary"
                disabled={props.submitDisabled}
                loading={props.pending}
                onClick={props.onSubmit}
            />
            {props.additionalButton && <props.additionalButton />}
        </>
    );
}
